import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorefrontAnalyticsRoutingModule } from '@teem/storefront-analytics/storefront-analytics-routing.module';
import { StorefrontAnalyticsComponent } from '@teem/storefront-analytics/storefront-analytics.component';
import { MostPopularProductsComponent } from '@teem/storefront-analytics/partials/most-popular-products/most-popular-products.component';
import { LeastPopularProductsComponent } from '@teem/storefront-analytics/partials/least-popular-products/least-popular-products.component';
import { TopCustomersComponent } from '@teem/storefront-analytics/partials/top-customers/top-customers.component';
import { TopCustomerLocationsComponent } from '@teem/storefront-analytics/partials/top-customer-locations/top-customer-locations.component';
import { InfluencerAnalyticsComponent } from '@teem/storefront-analytics/partials/influencer-analytics/influencer-analytics.component';
import { PromocodeAnalyticsComponent } from '@teem/storefront-analytics/partials/promocode-analytics/promocode-analytics.component';
import { HttpClientModule } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { environment } from '@teem/environments/environment';
import { AbandonedCartComponent } from '@teem/storefront-analytics/partials/abandoned-cart/abandoned-cart.component';
import { TopDistrictComponent } from './partials/top-district/top-district.component';
@NgModule({
  declarations: [
    StorefrontAnalyticsComponent,
    MostPopularProductsComponent,
    LeastPopularProductsComponent,
    TopCustomersComponent,
    TopCustomerLocationsComponent,
    InfluencerAnalyticsComponent,
    PromocodeAnalyticsComponent,
    AbandonedCartComponent,
    TopDistrictComponent
  ],
  imports: [
    StorefrontAnalyticsRoutingModule,
    CommonModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey,
      libraries: ['geometry', 'places']
    })
  ]
})
export class StorefrontAnalyticsModule { 

}
